import { ServicePermissions } from '@/enums/ServicePermissions'
import type { IAppMenuItem } from '@/models/Menu/IAppMenuItem'
import { computed } from 'vue'

import { type Composer } from 'vue-i18n'

export function getMenu(t: Composer['t']) {
  return computed((): IAppMenuItem[] => [
    {
      items: [
        {
          label: t('sidebar.dashboard'),
          icon: 'pi pi-fw pi-home',
          to: '/',
          separator: true,
          servicePermissions: [ServicePermissions.DashboardPermission]
        },
        {
          label: t('sidebar.siteMonitoring'),
          icon: 'fa fa-map-location',
          to: '/chargingsites',
          separator: false,
          servicePermissions: [ServicePermissions.SiteMonitoringPermission]
        },
        {
          label: t('sidebar.localControllers'),
          icon: 'fa fa-tachograph-digital',
          to: '/localcontrollers',
          separator: false,
          servicePermissions: [ServicePermissions.LocalControllerPermission]
        },
        {
          label: t('sidebar.chargePoints'),
          icon: 'fa fa-charging-station',
          to: '/chargepoints',
          separator: false,
          servicePermissions: [ServicePermissions.ChargePointsPermission]
        },
        {
          label: t('sidebar.chargingSessions'),
          icon: 'pi pi-fw pi-bolt',
          items: [
            {
              label: t('sidebar.authorisations'),
              icon: 'fa fa-lock-open',
              to: '/authorisations',
              separator: false,
              servicePermissions: [ServicePermissions.AuthorisationsPermission]
            },
            {
              label: t('sidebar.sessions'),
              icon: 'fa fa-wave-square',
              to: '/chargingsessions',
              separator: false,
              servicePermissions: [ServicePermissions.SessionPermission]
            }
          ]
        },
        {
          label: t('sidebar.loyalty'),
          icon: 'fa fa-gift',
          to: '/loyalty',
          separator: false,
          servicePermissions: [ServicePermissions.LoyaltyUsersPermission]
        },
        {
          label: t('sidebar.caseManagement'),
          icon: 'pi pi-lightbulb',
          items: [
            {
              label: t('sidebar.cases'),
              icon: 'pi pi-fw pi-file-o',
              to: '/casemanagement',
              separator: false,
              servicePermissions: [ServicePermissions.CaseManagementPermission]
            },
            {
              label: t('sidebar.workOrders'),
              icon: 'pi pi-fw pi-file-check',
              to: '/workorders',
              separator: false,
              servicePermissions: [ServicePermissions.WorkOrderPermission]
            }
          ]
        },
        {
          label: t('sidebar.reporting'),
          icon: 'fa fa-area-chart ',
          to: '/reporting',
          separator: false,
          servicePermissions: [ServicePermissions.ReportingPermission]
        },
        {
          label: t('sidebar.operations'),
          icon: 'fa fa-wrench',
          items: [
            {
              label: t('sidebar.firmwareManagement'),
              icon: 'fa fa-microchip',
              separator: false,
              servicePermissions: [ServicePermissions.FirmwarePermission],
              to: '/firmwaremanagement'
            },
            {
              label: t('sidebar.logs'),
              icon: 'fa fa-book-medical',
              separator: false,
              servicePermissions: [ServicePermissions.LogsPermission],
              to: '/logs'
            }
          ]
        },
        {
          label: t('sidebar.userManagement'),
          icon: 'fa fa-user',
          items: [
            {
              label: t('sidebar.organisations'),
              icon: 'fa fa-sitemap',
              separator: false,
              servicePermissions: [ServicePermissions.ServiceUserManagementOrganisationsView],
              to: '/organisations'
            },
            {
              label: t('sidebar.groups'),
              icon: 'fa fa-users-rectangle',
              separator: false,
              servicePermissions: [ServicePermissions.ServiceUserManagementGroupsView],
              to: '/groups'
            },
            {
              label: t('sidebar.permissions'),
              icon: 'fa fa-person-walking-dashed-line-arrow-right',
              separator: false,
              servicePermissions: [ServicePermissions.ServiceUserManagementPermissionsView],
              to: '/permissions'
            },
            {
              label: t('sidebar.roles'),
              icon: 'fa fa-arrows-down-to-people',
              separator: false,
              servicePermissions: [ServicePermissions.ServiceUserManagementRolesView],
              to: '/roles'
            },
            {
              label: t('sidebar.users'),
              icon: 'fa fa-users',
              separator: false,
              servicePermissions: [ServicePermissions.ServiceUserManagementUsersView],
              to: '/users'
            }
          ]
        }
      ] as IAppMenuItem[],
      separator: false
    }
  ])
}
